import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import QuickActionsFloatingWidget from '../widgets/QuickActionsFloatingWidget';
import ClientFloatingWidget from '../widgets/ClientFloatingWidget';
import { AnnouncementPopup } from '../announcements/AnnouncementComponents';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';

const MainLayout = ({ children, className }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { theme } = useTheme();
  const { user } = useAuth();

  // Determine which floating widget to show based on role
  const isClient = user?.role === 'client';
  const isAgency = user?.role === 'agency' || user?.role === 'project_manager';
  const isMember = user?.role === 'team_member' || user?.role === 'customer_service';

  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <Sidebar 
        collapsed={collapsed} 
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <Header collapsed={collapsed} setMobileOpen={setMobileOpen} />
      
      <main 
        className={cn(
          "transition-all duration-300 px-4 md:px-10 lg:px-16 pb-6 md:pb-8",
          collapsed ? "md:ml-20" : "md:ml-72",
          className
        )}
        style={{ paddingTop: "130px" }}
      >
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>

      {/* Floating Quick Actions Widget - only for agency */}
      {isClient && <ClientFloatingWidget />}
      {isAgency && <QuickActionsFloatingWidget />}
      
      {/* Popup Announcement */}
      <AnnouncementPopup />
    </div>
  );
};

export default MainLayout;
